
 
 

// import React, { useState, useEffect, useCallback, useRef } from "react";

// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";
// import imagesLoaded from "imagesloaded";
 
// // ====================== API BASE ======================
// const API_URL = "https://api.securxperts.com:8000";
 
// /* ============================================================
//    POPUP MODAL (UNCHANGED)
//    ============================================================ */
// const PopupModal = ({ show, onClose, type, message }) => {
//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40">
//       <div className="relative bg-white rounded-xl shadow-xl p-6 w-full max-w-md mx-4">
//         {/* ❌ CLOSE (manual close still available) */}
//         <button
//           onClick={onClose}
//           className="absolute top-3 right-3 text-gray-400 hover:text-gray-700 text-lg"
//         >
//           ✕
//         </button>

//         <h3
//           className={`text-xl font-semibold text-center ${
//             type === "success" ? "text-green-600" : "text-red-600"
//           }`}
//         >
//           {type === "success" ? "Success" : "Error"}
//         </h3>

//         <p className="mt-3 text-center text-gray-700">
//           {message}
//         </p>
//       </div>
//     </div>
//   );
// };

// const nameRegex = /^[A-Za-z\s]{3,50}$/;
// const onlyLetters = (value) =>
//   value.replace(/[^A-Za-z\s]/g, "");

// const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// const phoneRules = {
//   "+91": { min: 10, max: 10 }, // India
//   "+1": { min: 10, max: 10 },  // USA
//   "+44": { min: 10, max: 11 }, // UK
//   "+61": { min: 9, max: 9 },   // Australia
//   "+971": { min: 9, max: 9 },  // UAE
// };

// const yearRegex = /^(19|20)\d{2}$/;

// /* ============================================================
//    BUSINESS FORM
//    ============================================================ */
// const BusinessForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     country_code: "",
//     phoneno: "",
//     location: "",
//     industry_type: "",
//     name_of_business: "",
//     poc_name: "",
//     product_taking_time: "",
//   });
//   const [submitting, setSubmitting] = useState(false);

//   const [showModal, setShowModal] = useState(false);
//   const [modalData, setModalData] = useState({ type: "", message: "" });

//   const openModal = (type, message) => {
//     setModalData({ type, message });
//     setShowModal(true);
//     // window.scrollTo({ top: 0, behavior: "smooth" });

//     setTimeout(() => {
//       setShowModal(false);
//     }, 5000);
//   };

//  const handleChange = (e) => {
//   const { name, value } = e.target;
//   let updatedValue = value;

//   // ✅ Allow only letters & spaces
//   if (["name", "poc_name", "industry_type", "location"].includes(name)) {
//     updatedValue = value.replace(/[^A-Za-z\s]/g, "");
//   }

//   // ✅ Digits only for phone
//   if (name === "phoneno") {
//     updatedValue = value.replace(/\D/g, "");
//   }

//   setForm((prev) => ({
//     ...prev,
//     [name]: updatedValue,
//   }));
// };

 
// const validate = () => {
//   if (!form.name.trim())
//     return "Name is required";
//   if (!nameRegex.test(form.name))
//     return "Name must contain only letters (min 3 characters)";

//   if (!form.email.trim())
//     return "Email is required";
//   if (!emailRegex.test(form.email))
//     return "Enter a valid email address";

//   if (!form.country_code.trim())
//     return "Country code is required";

//   if (!form.phoneno.trim())
//     return "Phone number is required";

//   const rule = phoneRules[form.country_code];
//   if (!rule)
//     return "Invalid country code";

//   if (
//     form.phoneno.length < rule.min ||
//     form.phoneno.length > rule.max
//   ) {
//     return `Phone number must be ${rule.min}${
//       rule.min !== rule.max ? "-" + rule.max : ""
//     } digits`;
//   }

//   if (!form.location.trim())
//     return "Location is required";

//   if (!form.name_of_business.trim())
//     return "Business name is required";

//   if (!form.poc_name.trim())
//     return "Point of contact is required";

//   return null;
// };


//   const parseFastAPIError = (errorData) => {
//     if (!errorData) return "Unknown error";
//     if (errorData.detail) {
//       if (Array.isArray(errorData.detail)) {
//         return errorData.detail.map((err) => err.msg || "").join(", ");
//       } else if (typeof errorData.detail === "string") {
//         return errorData.detail;
//       }
//     }
//     return errorData.message || errorData.error || "Submission failed";
//   };
 
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const err = validate();
//     if (err) return openModal("error", err);

//     setSubmitting(true);

//     try {
//       const payload = {
//         name: form.name,
//         email: form.email,
//         country_code: form.country_code,
//         phoneno: form.phoneno,
//         location: form.location,
//         industry_type: form.industry_type,
//         name_of_business: form.name_of_business,
//         poc_name: form.poc_name,
//         product_taking_time: form.product_taking_time,
//       };

//       const resp = await fetch(`${API_URL}/forms/lauratek-b2b`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const result = await resp.json();

//       if (resp.ok) {
//         openModal("success", "Business enquiry submitted successfully!");
//         setForm({
//           name: "",
//           email: "",
//           country_code: "",
//           phoneno: "",
//           location: "",
//           industry_type: "",
//           name_of_business: "",
//           poc_name: "",
//           product_taking_time: "",
//         });
//       } else {
//         openModal("error", parseFastAPIError(result));
//       }
//     } catch {
//       openModal("error", "Network error. Please try again.");
//     }

//     setSubmitting(false);
//   };
 
//   return (
//     <>
//       <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20">
//         <h3 className="text-2xl font-bold text-white text-center mb-6">
//           Business Enquiry
//         </h3>
//         <form onSubmit={handleSubmit} className="space-y-5">
//           {/* All input fields remain exactly the same */}
//           <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name *" required className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" />
//           <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email Address *" required className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" />
//           <div className="flex gap-3">
//             <div className="w-[100px] relative">
//               <select name="country_code" value={form.country_code} onChange={handleChange} required className="w-full appearance-none px-4 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white focus:outline-none focus:border-white/60 transition">
//                 <option value="" className="text-black">Code</option>
//                 <option value="+91" className="text-black">🇮🇳 +91</option>
//                 <option value="+1" className="text-black">🇺🇸 +1</option>
//                 <option value="+44" className="text-black">🇬🇧 +44</option>
//                 <option value="+61" className="text-black">🇦🇺 +61</option>
//                 <option value="+971" className="text-black">🇦🇪 +971</option>
//               </select>
//               <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-white/70">▼</span>
//             </div>
//            <input
//   name="phoneno"
//   value={form.phoneno}
//   onChange={(e) => {
//     const digits = e.target.value.replace(/\D/g, "");
//     const rule = phoneRules[form.country_code];

//     if (!rule || digits.length <= rule.max) {
//       setForm((prev) => ({ ...prev, phoneno: digits }));
//     }
//   }}
//   placeholder="Phone Number *"
//   required
//   inputMode="numeric"
//   className="flex-1 min-w-0 px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60"
// />


//           </div>
//           <input name="location" value={form.location} onChange={handleChange} placeholder="City, Country" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
//           <input name="industry_type" value={form.industry_type} onChange={handleChange} placeholder="Industry Type" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
//           <input name="name_of_business" value={form.name_of_business} onChange={handleChange} placeholder="Business Name" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
//           <input name="poc_name" value={form.poc_name} onChange={handleChange} placeholder="Point of Contact" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
//           <input name="product_taking_time" value={form.product_taking_time} onChange={handleChange} placeholder="When do you plan to start?" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
  
//           <button
//             type="submit"
//             disabled={submitting}
//             className="w-full bg-gradient-to-r from-[#063852] to-[#0a5c7a] hover:from-[#052d40] hover:to-[#084d66] text-white font-bold py-4 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-70"
//           >
//             {submitting ? "Submitting..." : "Submit Business Enquiry"}
//           </button>
//         </form>
//       </div>

//       <PopupModal show={showModal} onClose={() => setShowModal(false)} type={modalData.type} message={modalData.message} />
//     </>
//   );
// };

// /* ============================================================
//    INQUIRY FORM
//    ============================================================ */
   
// const InquiryForm = () => {
//   const [form, setForm] = useState({
//     name: "",
//     email: "",
//     country_code: "",
//     phoneno: "",
//     purpose: "",
//     message: "",
//     course_type: "",
//     product_time: "",
//     location: "",
//     edu_status: "",
//     qualification: "",
//     passedout_year: "",
//     interest: "",
//   });
 
//   const [submitting, setSubmitting] = useState(false);
 
//   const [showModal, setShowModal] = useState(false);
//   const [modalData, setModalData] = useState({ type: "", message: "" });

//   const openModal = (type, message) => {
//     setModalData({ type, message });
//     setShowModal(true);
//     // window.scrollTo({ top: 0, behavior: "smooth" });

//     setTimeout(() => {
//       setShowModal(false);
//     }, 5000);
//   };

//  const handleChange = (e) => {
//   const { name, value } = e.target;
//   let updatedValue = value;

//   // Only letters
//   if (["name", "location", "qualification"].includes(name)) {
//     updatedValue = onlyLetters(value);
//   }

//   // Numbers only
//   if (["phoneno", "passedout_year"].includes(name)) {
//     updatedValue = value.replace(/\D/g, "");
//   }

//   setForm((prev) => ({
//     ...prev,
//     [name]: updatedValue,
//   }));
// };



// const validate = () => {
//   // Name
//   if (!form.name.trim()) return "Name is required";
//   if (!nameRegex.test(form.name))
//     return "Name must be 3–50 characters and contain only letters";

//   // Email
//   if (!form.email.trim()) return "Email is required";
//   if (!emailRegex.test(form.email))
//     return "Enter a valid email address";

//   // Country Code
//   if (!form.country_code) return "Country code is required";

//   // Phone
//   if (!form.phoneno) return "Phone number is required";
//   const rule = phoneRules[form.country_code];
//   if (!rule) return "Invalid country code";

//   if (
//     form.phoneno.length < rule.min ||
//     form.phoneno.length > rule.max
//   ) {
//     return `Phone number must be ${rule.min}${
//       rule.min !== rule.max ? "-" + rule.max : ""
//     } digits`;
//   }

//   // Course
//   if (!form.course_type.trim())
//     return "Interested course is required";

//   // Location
//   if (!form.location.trim())
//     return "Location is required";

//   // Purpose
//   if (!form.purpose.trim())
//     return "Purpose is required";

//   // Preferred time
//   if (!form.product_time.trim())
//     return "Preferred start time is required";

//   // Education status
//   if (!form.edu_status.trim())
//     return "Education status is required";

//   // Qualification
//   if (!form.qualification.trim())
//     return "Qualification is required";

//   // Passed out year
//   if (!form.passedout_year.trim())
//     return "Passed out year is required";
//   if (!yearRegex.test(form.passedout_year))
//     return "Enter a valid year (e.g. 2022)";

//   // Interest
//   if (!form.interest.trim())
//     return "Please specify your interest";

//   // Message
//   if (!form.message.trim())
//     return "Message is required";
//   if (form.message.trim().length < 10)
//     return "Message must be at least 10 characters";

//   return null;
// };


 
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const err = validate();
//     if (err) return openModal("error", err);

//     setSubmitting(true);

//     try {
//       const payload = {
//         name: form.name,
//         email: form.email,
//         country_code: form.country_code,
//         phoneno: form.phoneno,
//         purpose: form.purpose,
//         message: form.message,
//         course_type: form.course_type,
//         product_time: form.product_time,
//         location: form.location,
//         edu_status: form.edu_status,
//         qualification: form.qualification,
//         passedout_year: form.passedout_year,
//         interest: form.interest,
//       };

//       const resp = await fetch(`${API_URL}/forms/lauratek-b2c`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//       });

//       const result = await resp.json();

//       if (resp.ok) {
//         openModal("success", "Inquiry submitted successfully!");
//         setForm({
//           name: "",
//           email: "",
//           country_code: "",
//           phoneno: "",
//           purpose: "",
//           message: "",
//           course_type: "",
//           product_time: "",
//           location: "",
//           edu_status: "",
//           qualification: "",
//           passedout_year: "",
//           interest: "",
//         });
//       } else {
//         openModal("error", result.detail || "Submission failed");
//       }
//     } catch {
//       openModal("error", "Network error. Please try again.");
//     }

//     setSubmitting(false);
//   };
 
//   return (
//     <>
//       <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20">
//         <h3 className="text-2xl font-bold text-white text-center mb-6">
//           Student / Course Inquiry
//         </h3>
//         <form onSubmit={handleSubmit} className="space-y-5">
//           {/* All input fields remain exactly the same */}
//           <input name="name" value={form.name} onChange={handleChange} placeholder="Full Name *" required className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" />
//           <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Email Address *" required className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
//           <div className="flex gap-3">
//             <div className="w-[100px] relative">
//               <select name="country_code" value={form.country_code} onChange={handleChange} required className="w-full appearance-none px-4 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white focus:outline-none focus:border-white/60 transition">
//                 <option value="" className="text-black">Code</option>
//                 <option value="+91" className="text-black">🇮🇳 +91</option>
//                 <option value="+1" className="text-black">🇺🇸 +1</option>
//                 <option value="+44" className="text-black">🇬🇧 +44</option>
//                 <option value="+61" className="text-black">🇦🇺 +61</option>
//                 <option value="+971" className="text-black">🇦🇪 +971</option>
//               </select>
//               <span className="pointer-events-none absolute right-4 top-1/2 -translate-y-1/2 text-white/70">▼</span>
//             </div>
//           <input
//   name="phoneno"
//   value={form.phoneno}
//   onChange={(e) => {
//     const digits = e.target.value.replace(/\D/g, "");
//     const rule = phoneRules[form.country_code];

//     if (!rule || digits.length <= rule.max) {
//       setForm((prev) => ({ ...prev, phoneno: digits }));
//     }
//   }}
//   placeholder="Phone Number *"
//   required
//   inputMode="numeric"
//   className="flex-1 min-w-0 px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60"
// />

//           </div>
//           <input name="course_type" value={form.course_type} onChange={handleChange} placeholder="Interested Course" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
//           <input name="location" value={form.location} onChange={handleChange} placeholder="City, Country" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" />
//           <input
//      name="purpose"
//         value={form.purpose}
//           onChange={handleChange}
//            placeholder="Purpose (e.g. Enroll / Info)"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//        />
//         {/* <input
//            name="course_type"
//          onChange={handleChange}
//            placeholder="Course Type"
//            className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//        /> */}
//     <input
//           name="product_time"
//            value={form.product_time}
//            onChange={handleChange}
//           placeholder="Preferred Start Time"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//        />
      
//       <input
//            name="edu_status"
//           value={form.edu_status}
//            onChange={handleChange}
//           placeholder="Education Status (Student / Working)"
//         className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//       />
//          <input
//           name="qualification"
//            value={form.qualification}
//            onChange={handleChange}
//           placeholder="Qualification"
//            className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//        />
//         <input
//           name="passedout_year"
//            value={form.passedout_year}
//           onChange={handleChange}
//            placeholder="Passed Out Year"
//           className="w-full p-3 rounded-lg bg-white/10 placeholder-white/60 text-white outline-none"
//         />
       
//           <textarea name="message" value={form.message} onChange={handleChange} rows={4} placeholder="Your Message" className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 resize-none" />
 
//           <button
//             type="submit"
//             disabled={submitting}
//             className="w-full bg-gradient-to-r from-[#063852] to-[#0a5c7a] hover:from-[#052d40] hover:to-[#084d66] text-white font-bold py-4 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-70"
//           >
//             {submitting ? "Submitting..." : "Submit Inquiry"}
//           </button>
//         </form>
//       </div>

//       <PopupModal show={showModal} onClose={() => setShowModal(false)} type={modalData.type} message={modalData.message} />
//     </>
//   );
// };
 
// // ====================== MAIN COMPONENT ======================
// export default function LauratekLMS() {
//   /* ================= Scroll To Top ================= */
//   const [showScroll, setShowScroll] = useState(false);
//   const [dashOffset, setDashOffset] = useState(0);

//   const RADIUS = 45;
//   const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter" || e.key === " ") {
//       scrollToTop();
//     }
//   };

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollTop = window.scrollY;
//       const docHeight =
//         document.documentElement.scrollHeight -
//         document.documentElement.clientHeight;

//       const progress = scrollTop / docHeight;
//       const offset = CIRCUMFERENCE * (1 - progress);

//       setDashOffset(offset);
//       setShowScroll(scrollTop > 300);
//     };

//     window.addEventListener("scroll", handleScroll);
//     handleScroll();

//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);
//   return (
//     <div className="w-full overflow-x-hidden font-sans bg-white">
//      <div className="fixed top-0 left-0 w-full z-[9999]">
//   <Navbar />
// </div>

 
//       {/* HERO SECTION – UPDATED CONTENT */}
//       <section className="w-full bg-[#EAF4FF] px-6 md:px-20 py-16 relative overflow-hidden">
//         <div className="absolute top-0 right-0 w-[380px] h-[380px] bg-[#cfe3ff] rounded-full opacity-50 translate-x-24 -translate-y-10"></div>
 
//         <div className="grid md:grid-cols-2 gap-10 items-center relative z-10">
//           <div>
//             <img src="/img/110.png" alt="Logo" className="w-32 mb-6" />
//             <h1 className="text-4xl font-bold leading-tight text-[#063852] mb-8">
//               Advanced Digital Learning Platform
//             </h1>
//             <p className="text-[#063852] opacity-70 mb-12">
//               Lauratek provides a modern online learning platform with intuitive
//               course creation, live or on-demand sessions, and real-time learner
//               insights.
//             </p>
         
//           </div>
//           <div className="flex justify-center mb-[-92px]">
//             <img
//               src="/img/india Laura image 1.png"
//               alt="hero"
//               className="w-[320px] md:w-[380px] rounded-xl"
//             />
//           </div>
//         </div>
//       </section>
 
//       {/* FULL-WIDTH VIDEO SECTION – UPDATED CONTENT TEXT, SAME STRUCTURE */}
//       <section className="w-full  md:px-0 bg-gray-50">
//         <div className="max-w-7xl mx-auto">
//           <div className="max-w-3xl mx-auto mb-10 text-center">
//             <h2 className="text-2xl md:text-3xl font-bold text-[#063852]">
//               See Lauratek in Action
//             </h2>
//             <p className="text-[#063852] opacity-80 mt-3">
//               Explore our digital learning platform in a live demo &amp;
//               experience easy course creation, automated assessments, real-time
//               insights and smart reporting.
//             </p>
//           </div>
//           <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl group">
//             <video
//               className="w-full block"
//               src="/video/lauratekupdated.mp4"
//               muted
//               playsInline
//               autoPlay
//               loop
//               preload="auto"
//               controls={false}
//               key="lauratek-video"
//               onClick={(e) => {
//                 const v = e.currentTarget;
//                 v.paused ? v.play() : v.pause();
//               }}
//             >
//               Your browser does not support HTML5 video.
//             </video>
//             <div className="absolute bottom-6 right-6 md:bottom-8 md:right-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//               <button
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   const v =
//                     e.currentTarget.closest("div").querySelector("video");
//                   v.requestFullscreen?.() || v.webkitRequestFullscreen?.();
//                 }}
//                 className="bg-black/70 hover:bg-black/90 text-white p-4 rounded-xl backdrop-blur-md transition transform hover:scale-110 shadow-2xl"
//                 title="Fullscreen"
//               >
//                 <svg
//                   className="w-8 h-8"
//                   fill="none"
//                   stroke="currentColor"
//                   viewBox="0 0 24 24"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4-4l-5-5"
//                   />
//                 </svg>
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>
 
//       {/* INNOVATIVE LEARNING ENVIRONMENT – UPDATED CONTENT */}
//       <section className="w-full py-16 px-6 md:px-20">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-10">
//           Innovative Learning Environment
//         </h2>
//         <div className="grid md:grid-cols-4 gap-6">
//           {[
//             {
//               img: "/img/indlaura2.png",
//               title: "Modular Course Creation",
//               text: "Upload lessons, videos, slides, and materials. Organise them into flexible modules.",
//             },
//             {
//               img: "/img/indlaura3.png",
//               title: "Automated Knowledge Checks",
//               text: "Create quizzes, assignments, and auto-graded assessments with instant feedback.",
//             },
//             {
//               img: "/img/indlaura4.png",
//               title: "All-in-One Content Hub",
//               text: "Keep all PDFs, notes, multimedia, and references in a single accessible hub.",
//             },
//             {
//               img: "/img/indlaura5.png",
//               title: "Role-Based Access Panels",
//               text: "Custom dashboards for admins, trainers, and learners with relevant insights.",
//             },
//           ].map((item, i) => (
//             <div
//               key={i}
//               className="bg-white shadow-lg rounded-xl p-6 text-center border"
//             >
//               <img
//                 src={item.img}
//                 alt="card"
//                 className="w-12 h-12 mx-auto mb-4"
//               />
//               <h3 className="font-bold text-[#063852] mb-2">{item.title}</h3>
//               <p className="text-sm opacity-70">{item.text}</p>
//             </div>
//           ))}
//         </div>
//       </section>
 
//       {/* SMART LEARNING MANAGEMENT – UPDATED CONTENT */}
//       <section className="w-full px-6 md:px-20 bg-[#F5FAFF]">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-12">
//           Smart Learning Management for Optimal Efficiency
//         </h2>
//         <div className="max-w-3xl mx-auto">
//           <ul className="list-disc list-inside text-[#063852] leading-relaxed space-y-3">
//             <li>
//               <span className="font-semibold">
//                 Seamless Workflow Automation:
//               </span>{" "}
//               Automate routine tasks and reduce manual administration, supported
//               by simple dashboards for learning operations efficiently and
//               uninterrupted.
//             </li>
//             <li>
//               <span className="font-semibold">Learner Progress Tracking:</span>{" "}
//               Track each learner’s journey from enrolment to completion, with
//               detailed metrics and analytics to guide instructional strategies
//               effectively.
//             </li>
//             <li>
//               <span className="font-semibold">Advanced Reporting Tools:</span>{" "}
//               Generate instant reports, certificates and exportable analytics,
//               enhancing oversight and operational control across academic and
//               professional learning programs.
//             </li>
//             <li>
//               <span className="font-semibold">Secure Compliance Management:</span>{" "}
//               Store all data securely with audit-ready records and structured
//               reporting, ensuring consistent adherence to regulatory and
//               institutional standards.
//             </li>
//           </ul>
//         </div>
//       </section>
 
//       {/* KEY FEATURES OF DIGITAL LEARNING PLATFORM – UPDATED CONTENT */}
//       <section className="w-full py-16 px-6 md:px-20">
//         <h2 className="text-2xl font-bold text-[#063852] text-center mb-4">
//           Key Features of Digital Learning Platform
//         </h2>
//         <p className="text-center text-[#063852] opacity-80 max-w-3xl mx-auto mb-10">
//           Lauratek India equips educators and organisations with tools to plan,
//           deliver, and manage courses efficiently. Features like automated
//           assessments, instant certification, real-time dashboards, and a
//           centralised resource repository maximise engagement and productivity.
//         </p>
//         <div className="grid md:grid-cols-3 gap-6">
//           {[
//             {
//               img: "/img/indlaura6.jpg",
//               title: "Modular Course Builder",
//               text: "Create courses using flexible modules for live or pre-recorded sessions. Support varied teaching methods while organising content efficiently for easy learner access.",
//             },
//             {
//               img: "/img/indlaura7 (2).png",
//               title: "Smart Assessments",
//               text: "Design self-grading quizzes, assignments, and interactive tests. Provide instant feedback to learners while significantly reducing manual effort for instructors.",
//             },
//             {
//               img: "/img/indlaura8.jpg",
//               title: "Automated Certification",
//               text: "Automatically generate completion certificates for learners. Customise certificates with institutional branding to ensure professional and standardised recognition.",
//             },
//             {
//               img: "/img/indlaura9.jpg",
//               title: "Real-Time Analytics",
//               text: "Monitor learner attendance, engagement, and progress through interactive dashboards. Quickly identify learning gaps and adapt strategies to optimise outcomes.",
//             },
//             {
//               img: "/img/indlaura10 copy (2).png",
//               title: "Centralised Resource Hub",
//               text: "Store all educational content—notes, slides, PDFs, and multimedia—in one accessible hub. Ensure students and staff can retrieve materials instantly without searching.",
//             },
//             {
//               img: "/img/indlaura10.png",
//               title: "Role-Specific Reports",
//               text: "Provide administrators, instructors, and learners with custom dashboards. Generate detailed performance, attendance, and activity reports in a single click for clear oversight.",
//             },
//           ].map((f, i) => (
//             <div
//               key={i}
//               className="bg-white shadow-md border rounded-xl overflow-hidden"
//             >
//               <img
//                 src={f.img}
//                 alt={f.title}
//                className="w-full h-40 mt-2 object-contain bg-white"

//               />
//               <div className="p-5">
//                 <h3 className="font-bold text-[#063852]">{f.title}</h3>
//                 <p className="text-sm opacity-70 mt-2">{f.text}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </section>
 
//       {/* NEW PROFESSIONAL CONTACT SECTION – UNCHANGED STRUCTURE */}
//      <section
//   id="contact"
//   className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-[#063852] via-[#084d66] to-[#052d40] text-white"
// >
//   <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//     <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4">
//       Get in Touch
//     </h2>

//     <p className="text-base sm:text-lg text-white/80 max-w-2xl mx-auto mb-10 md:mb-12">
//       Whether you're a business or a student, we're here to help you get
//       started with Lauratek LMS.
//     </p>

//     <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 max-w-5xl mx-auto">
//       <BusinessForm />
//       <InquiryForm />
//     </div>
//   </div>
// </section>

 
//       <Footer />
//        {/* Scroll to Top Button */}
//       {showScroll && (
//         <div
//           onClick={scrollToTop}
//           onKeyDown={handleKeyDown}
//           role="button"
//           tabIndex={0}
//           className="scroll-top fixed bottom-6 right-6 z-50 cursor-pointer 
//           flex items-center justify-center w-14 h-14 rounded-full bg-gradient-to-r 
//           from-blue-500 to-blue-700 shadow-xl hover:scale-110 transition-all"
//         >
//           <svg className="progress-circle -rotate-90 w-12 h-12 absolute" viewBox="0 0 100 100">
//             <circle cx="50" cy="50" r={RADIUS} fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="4" />
//             <circle
//               cx="50"
//               cy="50"
//               r={RADIUS}
//               fill="none"
//               stroke="white"
//               strokeWidth="4"
//               strokeDasharray={CIRCUMFERENCE}
//               strokeDashoffset={dashOffset}
//               strokeLinecap="round"
//             />
//           </svg>

//           <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-white relative z-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//             <path strokeLinecap="round" strokeLinejoin="round" d="M5 15l7-7 7 7" />
//           </svg>
//         </div>
//       )}
//     </div>
//   );
// }
 
import React, { useEffect, useRef, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Flag from 'react-country-flag'; // npm install react-country-flag
import imagesLoaded from "imagesloaded";

// ====================== API BASE ======================
const API_URL = "https://api.securxperts.com:8000";

// ====================== COUNTRIES DATA ======================
const COUNTRIES = [
  { code: "+91", name: "India", iso: "IN" },
  { code: "+1", name: "United States", iso: "US" },
  { code: "+44", name: "United Kingdom", iso: "GB" },
  { code: "+61", name: "Australia", iso: "AU" },
  { code: "+971", name: "United Arab Emirates", iso: "AE" },
];

// ====================== COUNTRY DROPDOWN WITH FLAGS & SEARCH ======================
const CountryDropdown = ({ value, onChange, className = "" }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const dropdownRef = useRef(null);

  const filteredCountries = COUNTRIES.filter(
    (country) =>
      country.code.includes(search) ||
      country.name.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedCountry = COUNTRIES.find((c) => c.code === value) || null;

  const handleCountrySelect = (countryCode) => {
    onChange({ target: { name: "country_code", value: countryCode } });
    setIsOpen(false);
    setSearch("");
  };

  return (
    <div className={`w-full sm:w-[140px] relative ${className}`} ref={dropdownRef}>
      <div
        className="w-full px-4 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white cursor-pointer flex items-center justify-between transition-all duration-200 group hover:border-white/60"
        onClick={() => setIsOpen(!isOpen)}
      >
        {selectedCountry ? (
          <div className="flex items-center gap-2">
            <Flag
              countryCode={selectedCountry.iso}
              svg
              style={{
                width: '20px',
                height: '14px',
                borderRadius: '2px',
              }}
            />
            <span className="font-medium text-sm">{selectedCountry.code}</span>
          </div>
        ) : (
          <span className="text-white/60 text-sm">Code</span>
        )}
        <svg 
          className={`w-4 h-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>

      {isOpen && (
        <div className="absolute top-full left-0 w-full mt-2 bg-white/95 backdrop-blur-xl border border-white/40 rounded-xl shadow-2xl z-40 max-h-64 overflow-auto">
          <div className="p-3 border-b border-gray-200 sticky top-0 bg-white/95 backdrop-blur-sm">
            <input
              type="text"
              placeholder="Search country..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-lg text-sm text-gray-900 placeholder-gray-500 focus:outline-none focus:border-blue-500 focus:ring-1"
              autoFocus
            />
          </div>
          <div className="py-1">
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country) => (
                <div
                  key={country.code}
                  className="px-4 py-3 cursor-pointer hover:bg-gray-100 transition-colors flex items-center gap-3 group"
                  onClick={() => handleCountrySelect(country.code)}
                >
                  <Flag
                    countryCode={country.iso}
                    svg
                    style={{
                      width: '20px',
                      height: '14px',
                      borderRadius: '2px',
                    }}
                  />
                  <span className="font-medium text-gray-900">{country.code}</span>
                  <span className="text-xs text-gray-600 ml-auto truncate">
                    {country.name}
                  </span>
                </div>
              ))
            ) : (
              <div className="px-4 py-6 text-center text-sm text-gray-500">
                No countries found
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

/* ============================================================
   POPUP MODAL (UNCHANGED)
   ============================================================ */
const PopupModal = ({ show, onClose, type, message }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl p-8 max-w-sm w-full shadow-2xl relative animate-in fade-in zoom-in duration-200">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-2xl"
        >
          ×
        </button>
        <div className="text-center">
          {type === "success" && (
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
          )}
          <h3 className={`text-xl font-bold mb-2 ${
            type === "success" ? "text-green-600" : "text-red-600"
          }`}>
            {type === "success" ? "Success!" : "Error"}
          </h3>
          <p className="text-gray-600">{message}</p>
        </div>
      </div>
    </div>
  );
};

const nameRegex = /^[A-Za-z\s]{3,}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const phoneRegex = /^[0-9]{6,15}$/;  // Updated: shared regex for both forms
const phone10Regex = /^[0-9]{10}$/;  // Keep for InquiryForm if needed
const year4Regex = /^[0-9]{4}$/;

/* ============================================================
   BUSINESS FORM
   ============================================================ */
const BusinessForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    country_code: "",
    phoneno: "",
    location: "",
    industry_type: "",
    name_of_business: "",
    poc_name: "",
    product_taking_time: "",
  });
  const [submitting, setSubmitting] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "", message: "" });

  const openModal = (type, message) => {
    setModalData({ type, message });
    setShowModal(true);
    setTimeout(() => {
      setShowModal(false);
    }, 5000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    // Only letters
    if (["name", "location"].includes(name)) {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");
    }

    // Numbers only + max length
    if (name === "phoneno") {
      updatedValue = value.replace(/\D/g, "").slice(0, 15);  // FIXED: max 15 digits
    }

    // Time fields - allow any characters with maxLength 8
    if (["product_time", "product_taking_time"].includes(name)) {
      // No validation - allow any characters
    }

    setForm((prev) => ({ ...prev, [name]: updatedValue }));
  };

  const validate = () => {
    if (!form.name.trim()) return "Name is required";
    if (!nameRegex.test(form.name))
      return "Name should contain only alphabets (min 3 characters)";

    if (!form.email.trim()) return "Email is required";
    if (!emailRegex.test(form.email)) return "Enter a valid email";

    if (!form.country_code.trim()) return "Country code is required";
    if (!form.phoneno.trim()) return "Phone number is required";
    if (!phoneRegex.test(form.phoneno))  // UPDATED: consistent regex
      return "Phone number must be 6-15 digits";

    if (!form.product_taking_time.trim()) return "When do you plan to start is required";
    if (!/\d/.test(form.product_taking_time)) return "Should include a start date";
    if (!/[a-zA-Z]/.test(form.product_taking_time)) return "Should include both letters and numbers";

    return null;
  };

  const parseFastAPIError = (errorData) => {
    if (!errorData) return "Unknown error";
    if (errorData.detail) {
      if (Array.isArray(errorData.detail)) {
        return errorData.detail.map((err) => err.msg || "").join(", ");
      } else if (typeof errorData.detail === "string") {
        return errorData.detail;
      }
    }
    return errorData.message || errorData.error || "Submission failed";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const err = validate();
    if (err) return openModal("error", err);

    setSubmitting(true);

    try {
      const payload = {
        name: form.name,
        email: form.email,
        country_code: form.country_code,
        phoneno: form.phoneno,
        location: form.location,
        industry_type: form.industry_type,
        name_of_business: form.name_of_business,
        poc_name: form.poc_name,
        product_taking_time: form.product_taking_time,
      };

      const resp = await fetch(`${API_URL}/forms/lauratek-b2b`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await resp.json();

      if (resp.ok) {
        openModal("success", "Business enquiry Submitted Successfully!");
        setForm({
          name: "",
          email: "",
          country_code: "",
          phoneno: "",
          location: "",
          industry_type: "",
          name_of_business: "",
          poc_name: "",
          product_taking_time: "",
        });
      } else {
        openModal("error", parseFastAPIError(result));
      }
    } catch {
      openModal("error", "Network error. Please try again.");
    }

    setSubmitting(false);
  };

  return (
    <>
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20">
        <h3 className="text-2xl font-bold text-white text-center mb-6">
          Business Enquiry
        </h3>
        <form onSubmit={handleSubmit} className="space-y-5">
          <input 
            name="name" 
            value={form.name} 
            onChange={handleChange} 
            maxLength={60}
            placeholder="Full Name *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" 
          />
          
          <input 
            name="email" 
            type="email" 
            value={form.email} 
            onChange={handleChange}
            maxLength={60} 
            placeholder="Email Address *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" 
          />
          
          {/* FIXED: Responsive flex + maxLength */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <CountryDropdown 
              value={form.country_code}
              onChange={handleChange}
            />
            <input 
              name="phoneno" 
              type="tel"
              maxLength={10}
              value={form.phoneno} 
              onChange={handleChange} 
              placeholder="Phone Number *" 
              required
              className="flex-1 px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 min-w-0" 
            />
          </div>
          
          <input 
            name="location" 
            value={form.location} 
            onChange={handleChange} 
            placeholder="City, Country *" 
            maxLength={60}
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="industry_type" 
            value={form.industry_type} 
            onChange={handleChange} 
            placeholder="Industry Type *" 
            maxLength={60}
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="name_of_business" 
            value={form.name_of_business} 
            onChange={handleChange} 
            maxLength={60}
            placeholder="Business Name *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="poc_name" 
            value={form.poc_name} 
            onChange={handleChange} 
            maxLength={60}
            placeholder="Point of Contact *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="product_taking_time" 
            value={form.product_taking_time} 
            onChange={handleChange} 
            maxLength={8}
            placeholder="When do you plan to start? *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-gradient-to-r from-[#063852] to-[#0a5c7a] hover:from-[#052d40] hover:to-[#084d66] text-white font-bold py-4 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-70"
          >
            {submitting ? "Submitting..." : "Submit Business Enquiry"}
          </button>
        </form>
      </div>

      <PopupModal show={showModal} onClose={() => setShowModal(false)} type={modalData.type} message={modalData.message} />
    </>
  );
};

/* ============================================================
   INQUIRY FORM
   ============================================================ */
const InquiryForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    country_code: "",
    phoneno: "",
    purpose: "",
    message: "",
    course_type: "",
    product_time: "",
    location: "",
    edu_status: "",
    qualification: "",
    passedout_year: "",
    interest: "",
  });

  const [submitting, setSubmitting] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "", message: "" });

  const openModal = (type, message) => {
    setModalData({ type, message });
    setShowModal(true);
    setTimeout(() => {
      setShowModal(false);
    }, 5000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let updatedValue = value;

    // Only letters
    if (["name", "location", "qualification", "purpose", "edu_status", "interest","course_type"].includes(name)) {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");
    }

    // Only digits + limits
    if (["phoneno", "passedout_year"].includes(name)) {
      updatedValue = value.replace(/\D/g, "");
    }

    // Time fields - allow any characters with maxLength 8
    if (name === "product_time") {
      // No validation - allow any characters
    }

    // FIXED: Phone → max 15 digits (international)
    if (name === "phoneno") {
      updatedValue = updatedValue.slice(0, 15);
    }

    // Passed out year → max 4 digits
    if (name === "passedout_year") {
      updatedValue = updatedValue.slice(0, 4);
    }

    setForm((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  const validate = () => {
    if (!form.name.trim())
      return "Name is required";

    if (!form.email.trim())
      return "Email is required";

    if (!form.country_code)
      return "Country code is required";

    if (!form.phoneno)
      return "Phone number is required";

    if (!phoneRegex.test(form.phoneno))  // FIXED: Use shared 6-15 digits regex
      return "Phone number must be 6-15 digits";

    if (!form.course_type.trim())
      return "Interested course is required";

    if (!form.location.trim())
      return "Location is required";

    if (!form.purpose.trim())
      return "Purpose of learning is required";

    if (!form.product_time)
      return "Preferred start time is required";
    if (!/\d/.test(form.product_time)) return "Should include a start date";
    if (!/[a-zA-Z]/.test(form.product_time)) return "Should include both letters and numbers";

    if (!form.edu_status.trim())
      return "Education status is required";

    if (!form.qualification.trim())
      return "Qualification is required";

    if (!form.passedout_year)
      return "Passed out year is required";

    if (!year4Regex.test(form.passedout_year))
      return "Passed out year must be exactly 4 digits (e.g. 2022)";

    if (!form.interest.trim())
      return "Interest is required";

    if (!form.message.trim())
      return "Message is required";

    if (form.message.trim().length < 10)
      return "Message must be at least 10 characters";

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const err = validate();
    if (err) return openModal("error", err);

    setSubmitting(true);

    try {
      const payload = {
        name: form.name,
        email: form.email,
        country_code: form.country_code,
        phoneno: form.phoneno,
        purpose: form.purpose,
        message: form.message,
        course_type: form.course_type,
        product_time: form.product_time,
        location: form.location,
        edu_status: form.edu_status,
        qualification: form.qualification,
        passedout_year: form.passedout_year,
        interest: form.interest,
      };

      const resp = await fetch(`${API_URL}/forms/lauratek-b2c`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const result = await resp.json();

      if (resp.ok) {
        openModal("success", "Inquiry submitted successfully!");
        setForm({
          name: "",
          email: "",
          country_code: "",
          phoneno: "",
          purpose: "",
          message: "",
          course_type: "",
          product_time: "",
          location: "",
          edu_status: "",
          qualification: "",
          passedout_year: "",
          interest: "",
        });
      } else {
        openModal("error", result.detail || "Submission failed");
      }
    } catch {
      openModal("error", "Network error. Please try again.");
    }

    setSubmitting(false);
  };

  return (
    <>
      <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 shadow-2xl border border-white/20">
        <h3 className="text-2xl font-bold text-white text-center mb-6">
          Student / Course Inquiry
        </h3>
        <form onSubmit={handleSubmit} className="space-y-5">
          <input 
            name="name" 
            value={form.name} 
            onChange={handleChange} 
            maxLength={60}
            placeholder="Full Name *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 transition" 
          />
          
          <input 
            name="email" 
            type="email" 
            value={form.email} 
            maxLength={60}
            onChange={handleChange} 
            placeholder="Email Address *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          {/* FIXED: Responsive flex + maxLength */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <CountryDropdown 
              value={form.country_code}
              onChange={handleChange}
            />
            <input 
              name="phoneno" 
              type="tel"
              maxLength={10}
              value={form.phoneno} 
              onChange={handleChange} 
              placeholder="Phone Number *" 
              required
              className="flex-1 px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 min-w-0" 
            />
          </div>
          
          <input 
            name="course_type" 
            value={form.course_type} 
            onChange={handleChange} 
            maxLength={60}
            placeholder="Interested Course *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="location" 
            value={form.location} 
            maxLength={60}
            onChange={handleChange} 
            placeholder="City, Country *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="purpose" 
            value={form.purpose} 
            onChange={handleChange} 
            maxLength={60}
            placeholder="Purpose of Learning *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="product_time" 
            value={form.product_time} 
            onChange={handleChange} 
            maxLength={8}
            placeholder="Preferred Start Time *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="edu_status" 
            value={form.edu_status} 
            maxLength={60}
            onChange={handleChange} 
            placeholder="Education Status (Student / Working) *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="qualification" 
            value={form.qualification} 
            onChange={handleChange} 
            maxLength={60}
            placeholder="Qualification (e.g., B.Tech, MCA, etc.) *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="passedout_year" 
            value={form.passedout_year} 
            onChange={handleChange} 
            maxLength={4}
            placeholder="Passed Out Year (e.g., 2022) *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <input 
            name="interest" 
            value={form.interest} 
            onChange={handleChange} 
            maxLength={60}
            placeholder="Your Interest in the Course *" 
            required
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60" 
          />
          
          <textarea 
            name="message" 
            value={form.message} 
            onChange={handleChange} 
            rows={4} 
            placeholder="Your Message *" 
            className="w-full px-5 py-3.5 bg-white/10 border border-white/30 rounded-xl text-white placeholder-white/60 focus:outline-none focus:border-white/60 resize-none" 
          />
          
          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-gradient-to-r from-[#063852] to-[#0a5c7a] hover:from-[#052d40] hover:to-[#084d66] text-white font-bold py-4 rounded-xl shadow-lg transition transform hover:scale-105 disabled:opacity-70"
          >
            {submitting ? "Submitting..." : "Submit Inquiry"}
          </button>
        </form>
      </div>

      <PopupModal show={showModal} onClose={() => setShowModal(false)} type={modalData.type} message={modalData.message} />
    </>
  );
};

// ====================== MAIN COMPONENT ======================
export default function LauratekLMS() {

  useEffect(() => {
    // Disable browser scroll restoration
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    
    // Force scroll to top on component mount with multiple attempts
    const forceScrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      if (window.scrollY !== 0) {
        // If still not at top, try again after a short delay
        setTimeout(forceScrollToTop, 50);
      }
    };
    
    forceScrollToTop();
    
    // Additional fallback for stubborn browsers
    setTimeout(forceScrollToTop, 100);
    setTimeout(forceScrollToTop, 300);
    
    return () => {
      // Restore scroll restoration when component unmounts
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []);

  return (
    <div className="w-full overflow-x-hidden font-sans bg-white">
      <div className="fixed top-0 left-0 w-full z-[9999]">
        <Navbar />
      </div>

      {/* HERO SECTION – UPDATED CONTENT */}
      <section className="w-full bg-[#EAF4FF] px-6 md:px-20 py-16 relative overflow-hidden">
        <div className="absolute top-0 right-0 w-[380px] h-[380px] bg-[#cfe3ff] rounded-full opacity-50 translate-x-24 -translate-y-10"></div>

        <div className="grid md:grid-cols-2 gap-10 items-center relative z-10">
          <div>
            <img src="/img/110.png" alt="Logo" className="w-32 mb-6" />
            <h1 className="text-4xl font-bold leading-tight text-[#063852] mb-8">
              Advanced Digital Learning Platform
            </h1>
            <p className="text-[#063852] opacity-70 mb-12">
              Lauratek provides a modern online learning platform with intuitive
              course creation, live or on-demand sessions, and real-time learner
              insights.
            </p>
          </div>
          <div className="flex justify-center mt-2">
            <img
              src="/img/india Laura image 1.png"
              alt="hero"
              className="w-[400px] md:w-[480px] rounded-xl"
            />
          </div>
        </div>
      </section>

      {/* FULL-WIDTH VIDEO SECTION – UPDATED CONTENT TEXT, SAME STRUCTURE */}
      <section className="w-full py-20 px-6 md:px-0 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-3xl mx-auto mb-10 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-[#063852]">
              See Lauratek in Action
            </h2>
            <p className="text-[#063852] opacity-80 mt-3">
              Explore our digital learning platform in a live demo &amp;
              experience easy course creation, automated assessments, real-time
              insights and smart reporting.
            </p>
          </div>
           <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl">
            <video
              className="w-full h-auto max-h-[240px] sm:max-h-[360px] md:max-h-none block"
              src="/video/lauratekupdated.mp4"
              autoPlay
              loop
              muted
              playsInline
              preload="auto"
              controls
            >
              Your browser does not support HTML5 video.
            </video>
          </div>

        </div>
      </section>

            {/* INNOVATIVE LEARNING ENVIRONMENT – UPDATED CONTENT */}
      <section className="w-full py-16 px-6 md:px-20">
        <h2 className="text-4xl font-bold text-[#063852] text-center mb-10">
          Innovative Learning Environment
        </h2>
        <div className="grid md:grid-cols-4 gap-6">
          {[
            {
              img: "/img/indlaura2.png",
              title: "Modular Course Creation",
              text: "Upload lessons, videos, slides, and materials. Organise them into flexible modules.",
            },
            {
              img: "/img/indlaura3.png",
              title: "Automated Knowledge Checks",
              text: "Create quizzes, assignments, and auto-graded assessments with instant feedback.",
            },
            {
              img: "/img/indlaura4.png",
              title: "All-in-One Content Hub",
              text: "Keep all PDFs, notes, multimedia, and references in a single accessible hub.",
            },
            {
              img: "/img/indlaura5.png",
              title: "Role-Based Access Panels",
              text: "Custom dashboards for admins, trainers, and learners with relevant insights.",
            },
          ].map((item, i) => (
            <div
              key={i}
              className="bg-white shadow-lg rounded-xl p-6 text-center border"
            >
              <img
                src={item.img}
                alt="card"
                className="w-12 h-12 mx-auto mb-4"
              />
              <h4 className="font-bold text-[#063852] mb-2">{item.title}</h4>
              <p className="text-sm opacity-70">{item.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* SMART LEARNING MANAGEMENT – UPDATED CONTENT */}
      <section className="w-full py-16 px-6 md:px-20 bg-[#F5FAFF]">
        <h2 className="text-2xl font-bold text-[#063852] text-center mb-12">
          Smart Learning Management for Optimal Efficiency
        </h2>
        <div className="max-w-3xl mx-auto">
          <ul className="list-disc list-inside text-[#063852] leading-relaxed space-y-3">
            <li>
              <span className="font-semibold">
                Seamless Workflow Automation:
              </span>{" "}
              Automate routine tasks and reduce manual administration, supported
              by simple dashboards for learning operations efficiently and
              uninterrupted.
            </li>
            <li>
              <span className="font-semibold">Learner Progress Tracking:</span>{" "}
              Track each learner's journey from enrolment to completion, with
              detailed metrics and analytics to guide instructional strategies
              effectively.
            </li>
            <li>
              <span className="font-semibold">Advanced Reporting Tools:</span>{" "}
              Generate instant reports, certificates and exportable analytics,
              enhancing oversight and operational control across academic and
              professional learning programs.
            </li>
            <li>
              <span className="font-semibold">Secure Compliance Management:</span>{" "}
              Store all data securely with audit-ready records and structured
              reporting, ensuring consistent adherence to regulatory and
              institutional standards.
            </li>
          </ul>
        </div>
      </section>

      {/* KEY FEATURES OF DIGITAL LEARNING PLATFORM – UPDATED CONTENT */}
      <section className="w-full py-16 px-6 md:px-20">
        <h2 className="text-2xl font-bold text-[#063852] text-center mb-4">
          Key Features of Digital Learning Platform
        </h2>
        <p className="text-center text-[#063852] opacity-80 max-w-3xl mx-auto mb-10">
          Lauratek India equips educators and organisations with tools to plan,
          deliver, and manage courses efficiently. Features like automated
          assessments, instant certification, real-time dashboards, and a
          centralised resource repository maximise engagement and productivity.
        </p>
        <div className="grid md:grid-cols-3 gap-6">
          {[
            {
              img: "/img/indlaura6.jpg",
              title: "Modular Course Builder",
              text: "Create courses using flexible modules for live or pre-recorded sessions. Support varied teaching methods while organising content efficiently for easy learner access.",
            },
            {
              img: "/img/indlaura7 (2).png",
              title: "Smart Assessments",
              text: "Design self-grading quizzes, assignments, and interactive tests. Provide instant feedback to learners while significantly reducing manual effort for instructors.",
            },
            {
              img: "/img/indlaura8.jpg",
              title: "Automated Certification",
              text: "Automatically generate completion certificates for learners. Customise certificates with institutional branding to ensure professional and standardised recognition.",
            },
            {
              img: "/img/indlaura9.jpg",
              title: "Real-Time Analytics",
              text: "Monitor learner attendance, engagement, and progress through interactive dashboards. Quickly identify learning gaps and adapt strategies to optimise outcomes.",
            },
            {
              img: "/img/indlaura10 copy (2).png",
              title: "Centralised Resource Hub",
              text: "Store all educational content—notes, slides, PDFs, and multimedia—in one accessible hub. Ensure students and staff can retrieve materials instantly without searching.",
            },
            {
              img: "/img/indlaura10.png",
              title: "Role-Specific Reports",
              text: "Provide administrators, instructors, and learners with custom dashboards. Generate detailed performance, attendance, and activity reports in a single click for clear oversight.",
            },
          ].map((f, i) => (
            <div
              key={i}
              className="bg-white shadow-md border rounded-xl overflow-hidden"
            >
              <img
                src={f.img}
                alt={f.title}
                className="w-full h-40 mt-2 object-contain bg-white"
              />
              <div className="p-5">
                <h3 className="font-bold text-[#063852]">{f.title}</h3>
                <p className="text-sm opacity-70 mt-2">{f.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* NEW PROFESSIONAL CONTACT SECTION – UNCHANGED STRUCTURE */}
      <section
        id="contact"
        className="py-16 md:py-20 lg:py-24 bg-gradient-to-br from-[#063852] via-[#084d66] to-[#052d40] text-white"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-4">
            Get in Touch
          </h2>

          <p className="text-base sm:text-lg text-white/80 max-w-2xl mx-auto mb-10 md:mb-12">
            Whether you're a business or a student, we're here to help you get
            started with Lauratek LMS.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10 max-w-5xl mx-auto">
            <BusinessForm />
            <InquiryForm />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
